import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic";
import { links } from "links";
import { getCreatePathTemplate, getEntityPathTemplate } from "navigation";
import { Permissions } from "permissions";
import { RouteDescription } from "types";

const VerificationTypeListPage = lazy(() => import("./VerificationTypeListPage"));
const VerificationTypePage = lazy(() => import("./VerificationTypePage"));

export const verificationTypesRoutes: RouteDescription[] = [
  {
    path: links.verificationType,
    element: withPageLoader(<VerificationTypeListPage />),
    breadcrumb: "Verification types",
    menuItem: {
      id: "verificationTypes",
      label: "Verification types",
    },
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
  {
    path: getCreatePathTemplate(links.verificationType),
    element: withPageLoader(<VerificationTypePage />),
    breadcrumb: "Create new verification type",
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
  {
    path: getEntityPathTemplate(links.verificationType),
    element: withPageLoader(<VerificationTypePage />),
    breadcrumb: "Verification type",
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
];
